import { Grid } from "@mui/material";
import HeadersPlanTable from "./HeadersPlanTable";
import PlansTable from "./PlansTable";
import CreatePlanModal from "./CreatePlanModal";
import EditPlanModal from "./EditPlanModal";
import { useSuperAdminPlans } from "../../../context/SuperAdmin/PlanContext";
import { Spinner } from "../../Loading/Spinner";
import { useAuthContext } from "../../../hooks/Auth";
import DeletePlanModal from "./DeletePlanModal";

const PlansPanel = () => {
  const { isLoadingPlans } = useSuperAdminPlans();
  const { canAccess } = useAuthContext();

  if (isLoadingPlans) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <>
      {/* Crear plan */}
      <Grid item>
        <HeadersPlanTable />
      </Grid>

      {/* Tabla de planes */}
      <Grid item>
        <PlansTable />
      </Grid>

      {/* Modal para crear plan */}
      {canAccess("create:plans") && (
        <Grid item>
          <CreatePlanModal />
        </Grid>
      )}

      {/* Modal para editar plan */}
      {canAccess("edit:plans") && (
        <Grid item>
          <EditPlanModal />
        </Grid>
      )}

      {/* Modal para borrar plan */}
      {canAccess("delete:plans") && (
        <Grid item>
          <DeletePlanModal />
        </Grid>
      )}
    </>
  );
};

export default PlansPanel;
